<template>
  <div class="bankCodeField">
    <div class="label"><span class="required">*</span>{{ label }}</div>
    <div class="value">
      <input
        type="number"
        pattern="\d*"
        oninput="value=value.replace(/[^\d]/g,'')"
        v-model="code"
        @input="onInput"
        placeholder="请输入"
      />
      <span :style="{ color: color }" class="code" @click="getCode">{{ getCodeText }}</span>
    </div>
  </div>
</template>

<script>
import { sendSmsCode } from "@/api/index.js";
import { encrypt } from "@/utils/crypto.js";
export default {
  name: "BankCodeField",
  components: {},
  props: {
    label: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      default: "",
    },
    phone: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      code: "",
      getCodeText: "获取验证码",
      timer: null,
      counter: 60,
      isSend: false,
      color: "#F24334",
    };
  },
  methods: {
    init() {
      this.getCodeText = "获取验证码";
      this.code = "";
      clearInterval(this.timer);
      this.counter = 60;
      this.timer = null;
      this.color = "#F24334";
      this.isSend = false;
    },
    onInput(val) {
      if (val.target.value.length > 6) {
        this.code = val.target.value.slice(0, 6);
      }
      this.$emit("input", this.code);
    },
    countDown() {
      this.timer = setInterval(() => {
        this.isSend = true;
        this.getCodeText = `${this.counter}秒后重发`;
        this.counter--;
        this.color = "rgba(51,51,51,0.4)";
        if (this.counter < 0) {
          this.getCodeText = "获取验证码";
          this.isSend = false;
          this.color = "#F24334";
          if (this.timer) {
            clearInterval(this.timer);
            this.counter = 60;
            this.timer = null;
          }
        }
      }, 1000);
    },
    getCode() {
      if (this.isSend) return;

      sendSmsCode({
        phoneNumber: this.phone,
        captchaType: "Bank",
        sign: encrypt(this.phone + 'Bank'),
      }).then((res) => {
        if (res.code !== 2000) {
          this.$toast(res.msg || res.message || "请求失败");
          return;
        } else {
          this.countDown();
          this.$toast("验证码发送成功");
        }
      });
    },
  },
  watch: {
    value(newVal) {
      this.code = newVal;
    },
  },
};
</script>

<style scoped lang="scss">
.bankCodeField {
  display: flex;
  align-items: center;
  padding: 12px 0px;
}
.label {
  font-size: 14px;
  color: #333333;
  width: 70px;
  .required {
    color: #ff4444;
  }
}
.value {
  flex: 1;
  display: flex;
  align-items: center;
  height: 38px;
  justify-content: space-between;
  border-radius: 17px;
  background: #f8f8f8;
  padding: 0px 12px;

  input {
    border: none;
    outline: none;
    background: transparent;
    font-size: 14px;
    width: 80px;
    color: #333333;
    &::placeholder {
      color: rgba(170, 170, 170, 0.67);
    }
  }
  .code {
    font-size: 14px;
  }
}
</style>
